import { Column, ColumnType, Flex } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import dateRenderer from '@elementary/common-ui/components/cellRenderers/dateRenderer';
import dateComparer from '@elementary/common-ui/utils/comparers/dateComparer';
import { fontFamily, fontSize } from '@elementary/common-ui/style/utils';
import { GPGKey, GPGKeyStatus } from '../types';
import GPGKeyActions from '../components/GPGKeyActions';
import GPGKeyStatusChip from '../components/GPGKeyStatusChip';

const useGPGKeysColumns = () => {
  const columns: Column<GPGKey>[] = [
    {
      id: 'keyId',
      header: 'Key ID',
      renderer: (key) => (
        <Flex sx={{ alignItems: 'center', gap: 1 }}>
          <Typography
            variant="body2"
            sx={{ fontFamily: fontFamily('mono'), fontSize: fontSize('md') }}
          >
            {key.keyId}
          </Typography>
        </Flex>
      ),
      isFilterCounterHidden: true,
    },
    {
      id: 'fingerprint',
      header: 'Fingerprint',
      renderer: (key) => (
        <Typography
          variant="body2"
          sx={{
            fontFamily: fontFamily('mono'),
            fontSize: fontSize('xs'),
            wordBreak: 'break-all',
          }}
        >
          {key.fingerprint}
        </Typography>
      ),
      isFilterCounterHidden: true,
      width: 300,
    },
    {
      id: 'createdAt',
      header: 'Created',
      type: ColumnType.Date,
      renderer: (key) => dateRenderer(key.createdAt, 'L'),
      compareFunc: (a, b) => dateComparer(a.createdAt, b.createdAt),
    },
    {
      id: 'status',
      header: 'Status',
      renderer: (key) => <GPGKeyStatusChip gpgKey={key} />,
      filterOptionsOverride: [
        { label: 'Active', value: GPGKeyStatus.active },
        { label: 'Expired', value: GPGKeyStatus.expired },
        { label: 'Revoked', value: GPGKeyStatus.revoked },
      ],
      filterValueMatcher: (selectedFilterValues, rowData) =>
        selectedFilterValues.includes(rowData.status),
    },
    {
      id: 'actions',
      header: '',
      renderer: (key) => <GPGKeyActions gpgKey={key} />,
      filterable: false,
      sortable: false,
      metaColumn: true,
      width: 100,
    },
  ];

  return columns;
};

export default useGPGKeysColumns;
